/* @flow */
import CurrentUser from 'auth/CurrentUser';
import * as React from 'react';
import GroupStore from 'groups/stores/GroupStore';
import TitleHeader from 'components/TitleHeader.jsx';
import TriggerComposerButton from 'chat/components/TriggerComposerButton.jsx';
import View from 'components/View.jsx';

import './styles/ChatLearnMore.scss';

type Props = {
  groupCode: string,
};

function ChatLearnMore({ groupCode }: Props) {
  const group = GroupStore.getGroupForCode(groupCode);
  const isGroupOwner = !!group && group.isOwnedByUser(CurrentUser.getUserId());
  const title = 'Direct, reliable messaging. Built for education.';
  let subtext = 'Reach individuals and groups by text, app, web, and email.';

  const composeButton = (
    <TriggerComposerButton
      hideAnnouncements={!isGroupOwner}
      label="Get started"
      level="secondary"
      className="ChatLearnMore-action"
    />
  );

  if (CurrentUser.getUser().isUnderage()) {
    subtext =
      'Never miss a class announcement. Once you turn 13, you can reply to messages you receive.';
  }

  return (
    <View className="ChatLearnMore">
      <TitleHeader
        action={CurrentUser.getUser().canChat() && composeButton}
        flush
        image={require('assets/images/chat/ChatLearnMore/apps.svg')}
        subtext={subtext}
        title={title}
      />
    </View>
  );
}

export default ChatLearnMore;
